import { render, staticRenderFns } from "./student-travel-grants.vue?vue&type=template&id=3c29fc50&scoped=true&"
import script from "./student-travel-grants.vue?vue&type=script&lang=js&"
export * from "./student-travel-grants.vue?vue&type=script&lang=js&"
import style0 from "./student-travel-grants.vue?vue&type=style&index=0&id=3c29fc50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c29fc50",
  null
  
)

export default component.exports